'use client';

import { useEffectEvent } from "@floating-ui/react/utils";
import { styled } from "@linaria/react";
import { CSSProperties, PropsWithChildren, useEffect, useId, useLayoutEffect, useRef } from "react";
import { THEME_HUE } from "../global.linaria.global";
import "./PDFDownloadButtonBorder.linaria.module.css!=!./PDFDownloadButtonBorder?./PDFDownloadButtonBorder.linaria.module.css?css=H4sIAAAAAAAAA62T25abIBSGr5On4FLbYlEnaQtPA4i6JwQMoDGZlXfv0hycNHHaWat3m338vw0kfrt+eQk/3hrrIYA11CnNA3SKCesK5bDjBbSegqmVg8Bsp1yp7Z524EFoxcDbocAaerYUOy0TLwlkzWHqWkKvCqZVGShOCSGk6VmwzXTYQxFqmg5mraCqw9m2DZcQDpQkhKSssWCCclh1ygRPjTXjNPmaV8fCvz1XfFomOs2KfFW2kx4uvNVtUAyMV4GSGdpnA48YTKF6mg2dhSnXfn/4L42F7bGHI5iKXoqE7cdt/hLla8dvw85R2nEXYXwJYhIjbzUU6N6dxgzvldhAwCXo8FCWxUjo1kX33jyO2SfTT8uk2shtMOK5zktw0mk3WtZR6ewW3WekMdJIohp9RyRZx+/ewOpPllGL5FpGJFk1PfqKoodpXxBJslU8EX2uaOBKd7tu3ZAZsEv0I7JryhXtH6GyO3Xv5gzyniP9vWR4telOgmn1Dej6pnF6ExMcN760bku95FpFaUJ+xgxv7XE25GciM/lPqPOs6e+hzp5pWzkTXG4qZ1tTUA1GcYer4XMpEyKck0JV35aLxeLhDq7Mwy7OdzDmjdoa7pQJ4/kheVjYb+m7z9wmBQAA"
export const StyledElectricBorder = /*#__PURE__*/styled('div')({
  name: "StyledElectricBorder",
  class: "sm644t7",
  propsAsIs: false
});
export const SVG = /*#__PURE__*/styled('svg')({
  name: "SVG",
  class: "sc0i2py",
  propsAsIs: false
});
export const ContentDiv = /*#__PURE__*/styled('div')({
  name: "ContentDiv",
  class: "cj3gzds",
  propsAsIs: false
});
export const LayersDiv = /*#__PURE__*/styled('div')({
  name: "LayersDiv",
  class: "l12d35fu",
  propsAsIs: false
});
export const BaseLayer = /*#__PURE__*/styled('div')({
  name: "BaseLayer",
  class: "bnf6swy",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => BaseLayer;
const _exp2 = /*#__PURE__*/() => p => `${p.borderWidthPx}px`;
const _exp3 = /*#__PURE__*/() => p => p.borderColor;
const _exp4 = /*#__PURE__*/() => p => `url(#${p.filterId})`;
const _exp5 = /*#__PURE__*/() => p => `${p.borderWidthPx / 4}px`;
export const Stroke = /*#__PURE__*/styled(_exp())({
  name: "Stroke",
  class: "s9bfjva",
  propsAsIs: true,
  vars: {
    "s9bfjva-0": [_exp2()],
    "s9bfjva-1": [_exp3()],
    "s9bfjva-2": [_exp4()],
    "s9bfjva-3": [_exp5()]
  }
});
const _exp6 = /*#__PURE__*/() => BaseLayer;
const _exp8 = /*#__PURE__*/() => p => p.borderColor;
const _exp9 = /*#__PURE__*/() => p => p.borderWidth;
export const Glow1 = /*#__PURE__*/styled(_exp6())({
  name: "Glow1",
  class: "gkcmtnb",
  propsAsIs: true,
  vars: {
    "gkcmtnb-0": [_exp9()],
    "gkcmtnb-1": [_exp8()]
  }
});
const _exp0 = /*#__PURE__*/() => BaseLayer;
const _exp10 = /*#__PURE__*/() => p => p.borderColor;
const _exp11 = /*#__PURE__*/() => p => p.borderWidth;
export const Glow2 = /*#__PURE__*/styled(_exp0())({
  name: "Glow2",
  class: "g1qqv6p0",
  propsAsIs: true,
  vars: {
    "g1qqv6p0-0": [_exp11()],
    "g1qqv6p0-1": [_exp10()]
  }
});
const _exp12 = /*#__PURE__*/() => BaseLayer;
const _exp14 = /*#__PURE__*/() => p => p.borderColor;
export const BackgroundGlow = /*#__PURE__*/styled(_exp12())({
  name: "BackgroundGlow",
  class: "b1qcinul",
  propsAsIs: true,
  vars: {
    "b1qcinul-0": [_exp14()]
  }
});
type ElectricBorderProps = PropsWithChildren<{
  readonly color?: string;
  readonly chaos?: number;
  readonly thickness?: number;
  readonly className?: string;
  readonly style?: CSSProperties;
}>;
export function PDFDownloadButtonBorder({
  children,
  color = `hsl(${THEME_HUE}, 70%, 100%)`,
  chaos = 0.8,
  thickness = 5,
  className,
  style
}: ElectricBorderProps) {
  const rawId = useId().replace(/[:]/gu, "");
  const filterId = `turbulent-displace-${rawId}`;
  const svgRef = useRef<SVGSVGElement | null>(null);
  const rootRef = useRef<HTMLDivElement | null>(null);
  const strokeRef = useRef<HTMLDivElement | null>(null);
  const updateAnim = useEffectEvent(() => {
    const svg = svgRef.current;
    const host = rootRef.current;
    if (!svg || !host) return;
    const width = Math.max(1, Math.round(host.clientWidth || host.getBoundingClientRect().width || 0));
    const height = Math.max(1, Math.round(host.clientHeight || host.getBoundingClientRect().height || 0));
    const dyAnims = Array.from(svg.querySelectorAll<SVGAnimateElement>('feOffset > animate[attributeName="dy"]'));
    if (dyAnims.length >= 2) {
      dyAnims[0]!.setAttribute("values", `${3 * height}; -${height}`);
      dyAnims[1]!.setAttribute("values", `-${2 * height}; ${Math.round(height * 1.4 * Math.PI)}`);
    }
    const dxAnims = Array.from(svg.querySelectorAll<SVGAnimateElement>('feOffset > animate[attributeName="dx"]'));
    if (dxAnims.length >= 2) {
      dxAnims[0]!.setAttribute("values", `${2 * width}; -${2 * width}`);
      dxAnims[1]!.setAttribute("values", `-${2 * width}; ${Math.round(height * 0.15 * Math.PI)}`);
    }
    const anims = [...dyAnims, ...dxAnims];
    requestAnimationFrame(() => {
      anims.forEach((a: any) => {
        if (typeof a.beginElement !== "function") return;
        try {
          a.beginElement();
        } catch {}
      });
    });
  });
  useEffect(() => {
    updateAnim();
  }, [chaos, updateAnim]);
  useLayoutEffect(() => {
    if (!rootRef.current) return;
    const ro = new ResizeObserver(() => updateAnim());
    ro.observe(rootRef.current);
    updateAnim();
    return () => ro.disconnect();
  }, [updateAnim]);
  const borderWidth = `${thickness}px`;
  return <StyledElectricBorder ref={rootRef} className={className} style={style} borderColor={color} borderWidth={borderWidth}>
		<SVG ref={svgRef} aria-hidden focusable="false">
			<defs>
				<filter id={filterId} colorInterpolationFilters="sRGB" x="-200%" y="-200%" width="500%" height="500%">
					<feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise1" seed="1" />
					<feOffset in="noise1" dx="0" dy="0" result="offsetNoise1">
						<animate attributeName="dy" values="-201, -67" dur="12s" repeatCount="indefinite" calcMode="linear" />
					</feOffset>
					<feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise2" seed="1" />
					<feOffset in="noise2" dx="0" dy="0" result="offsetNoise2">
						<animate attributeName="dy" values="-134; 295" dur="7s" repeatCount="indefinite" calcMode="linear" />
					</feOffset>

					<feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise1" seed="2" />
					<feOffset in="noise1" dx="0" dy="0" result="offsetNoise3">
						<animate attributeName="dx" values="612; -612" dur="10s" repeatCount="indefinite" calcMode="linear" />
					</feOffset>

					<feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise2" seed="2" />
					<feOffset in="noise2" dx="0" dy="0" result="offsetNoise4">
						<animate attributeName="dx" values="612; 32" dur="14s" repeatCount="indefinite" calcMode="linear" />
					</feOffset>

					<feComposite in="offsetNoise1" in2="offsetNoise2" result="part1" />
					<feComposite in="offsetNoise3" in2="offsetNoise4" result="part2" />
					<feBlend in="part1" in2="part2" mode="color-dodge" result="combinedNoise" />
					<feDisplacementMap in="SourceGraphic" in2="combinedNoise" scale={30 * (chaos || 1)} xChannelSelector="R" yChannelSelector="B" />
				</filter>
			</defs>
		</SVG>

		<LayersDiv>
			<Stroke ref={strokeRef} borderColor={color} borderWidthPx={thickness} filterId={filterId} />
			<Glow1 borderColor={color} borderWidth={borderWidth} />
			<Glow2 borderColor={color} borderWidth={borderWidth} />
			<BackgroundGlow borderColor={color} />
		</LayersDiv>

		<ContentDiv>{children}</ContentDiv>
	</StyledElectricBorder>;
}
;